module.exports = __webpack_public_path__ + "/content/shared/img/mclaren/McLaren_LandingImage_7.jpg";